import { useToast } from '@chakra-ui/react';

export const useSubDetailToast = () => {
  const toast = useToast();
  const showSuccessToast = (msg: string | JSX.Element, duration?: number) => {
    toast({
      description: msg,
      status: 'success',
      isClosable: true,
      duration,
      position: 'top',
    });
  };

  const showErrorToast = (msg: string, title?: string) => {
    toast({
      description: msg,
      status: 'error',
      isClosable: true,
      position: 'top',
      title,
    });
  };

  const showWarningToast = (
    msg: string,
    title?: string,
    duration: number = 60000 /* 1 minute*/,
  ) => {
    toast({
      description: msg,
      status: 'warning',
      isClosable: true,
      position: 'top',
      duration,
      title,
    });
  };

  return {
    showSuccessToast,
    showErrorToast,
    showWarningToast,
  };
};
